import { render, staticRenderFns } from "./PictureVerifyChip.html?vue&type=template&id=0468b443&scoped=true&"
import script from "./PictureVerifyChip.js?vue&type=script&lang=js&"
export * from "./PictureVerifyChip.js?vue&type=script&lang=js&"
import style0 from "./PictureVerifyChip.scss?vue&type=style&index=0&id=0468b443&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468b443",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
